import { panelCreatedProps } from "../../pages/DashDyanalabs/Dashboard";
import { dataHistoryRecomendationProps } from "./Models";

export const Types = {
	PACIENTE_REQUEST: "PACIENTE_REQUEST",
	PACIENTE_NOTIFICATION_REQUEST: "PACIENTE_NOTIFICATION_REQUEST",
	AVALIADORES_REQUEST: "AVALIADORES_REQUEST",
	PACIENTE_REQUEST_SUCCESS: "PACIENTE_REQUEST_SUCCESS",
	PACIENTE_NOTIFICATION_REQUEST_SUCCESS:
		"PACIENTE_NOTIFICATION_REQUEST_SUCCESS",
	PACIENTE_STOP_REQUEST: "PACIENTE_STOP_REQUEST",
	TOTAL_PACIENTES: "PACIENTES_TOTAIS",
	TOTAL_AVALIADORES: "TOTAL_AVALIADORES",
	PACIENTE_REQUEST_FILTROS: "PACIENTE_REQUEST_FILTROS",
	PACIENTE_NOTIFICATION_REQUEST_FILTROS:
		"PACIENTE_NOTIFICATION_REQUEST_FILTROS",
	AVALIADOR_REQUEST_FILTROS: "AVALIADOR_REQUEST_FILTROS",
	SER_AVALIADORES: "SER_AVALIADORES",

	PROTOCOLOS_REQUEST: "PROTOCOLOS_REQUEST",

	EXERCICES_REQUEST: "EXERCICES_REQUEST",

	EXECUCOES_REQUEST: "EXECUCOES_REQUEST",
	EXECUCOES_REQUEST_SUCCESS: "EXECUCOES_REQUEST_SUCCESS",
	EXECUCOES_REQUEST_LOADING: "EXECUCOES_REQUEST_LOADING",

	SET_USER_MASTER: "SET_USER_MASTER",

	PACIENTE_FILTERED: "PACIENTE_FILTERED",

	SET_DESATIVADOS: "SET_DESATIVADOS",
	SET_AGRUPAMENTOS: "SET_AGRUPAMENTOS",
	SET_SEARCH: "SET_SEARCH",

	SET_DROP_DOWN: "SET_DROP_DOWN",

	ETIQUETAS_REQUEST: "ETIQUETAS_REQUEST",
	ETIQUETAS_REQUEST_SUCCESS: "ETIQUETAS_REQUEST_SUCCESS",

	NOTIFICACOES_REQUEST: "NOTIFICACOES_REQUEST",
	NOTIFICACOES_REQUEST_SUCCESS: "NOTIFICACOES_REQUEST_SUCCESS",

	ASSIMETRIA_REQUEST: "ASSIMETRIA_REQUEST",
	DESEQUILIBRIO_REQUEST_SUCCESS: "DESEQUILIBRIO_REQUEST_SUCCESS",
	ASSIMETRIA_REQUEST_SUCCESS: "ASSIMETRIA_REQUEST_SUCCESS",
	ASSIMETRIA_REQUEST_LOADING: "ASSIMETRIA_REQUEST_LOADING",

	ANAMNESES_REQUEST: "ANAMNESES_REQUEST",
	ANAMNESES_REQUEST_SUCCESS: "ANAMNESES_REQUEST_SUCCESS",
	ANAMNESES_REQUEST_LOADING: "ANAMNESES_REQUEST_LOADING",

	ANOTACOES_REQUEST: "ANOTACOES_REQUEST",
	EXERCICIOS_AVALIADOS_REQUEST: "EXERCICIOS_AVALIADOS_REQUEST",
	ANOTACOES_REUQUEST_SUCCESS: "ANOTACOES_REUQUEST_SUCCESS",
	DINAMOS_REQUEST: "DINAMOS_REQUEST",
	DINAMOS_REQUEST_SUCCESS: "DINAMOS_REQUEST_SUCCESS",

	LOADING: "LOADING",

	BLOG: "BLOG",
	SET_BLOG: "SET_BLOG",

	PLANOS_REQUEST: "PLANOS_REQUEST",
	PLANOS_REQUEST_SUCCESS: "PLANOS_REQUEST_SUCCESS",

	SELECT_INFO: "SELECT_INFO",
	SET_BUTTON_SEARCH: "SET_BUTTON_SEARCH",
	SET_CURRENT_PAGE_PATIENT: "SET_CURRENT_PAGE_PATIENT",
	SET_CURRENT_PAGE_EVALUATOR: "SET_CURRENT_PAGE_EVALUATOR",
	SET_PACIENTES_MAIS_VISITADOS: "SET_PACIENTES_MAIS_VISITADOS",
	PACIENTES_MAIS_VISITADOS_REQUEST: "PACIENTES_MAIS_VISITADOS_REQUEST",
	CATEGORIAS_PROTOCOLOS: "CATEGORIAS_PROTOCOLOS",
	SET_CATEGORIAS_PROTOCOLOS: "SET_CATEGORIAS_PROTOCOLOS",
	ATRIBUIR_CATEGORIA_PROTOCOLOS: "ATRIBUIR_CATEGORIA_PROTOCOLOS",
	SEARCH_CATEGORIAS_ATRIBUIDAS: "SEARCH_CATEGORIAS_ATRIBUIDAS",
	GET_CATEGORIAS_ATRIBUIDAS: "GET_CATEGORIAS_ATRIBUIDAS",
	SEARCH_PROTOCOL_IN_STORAGE: "SEARCH_PROTOCOL_IN_STORAGE",
	SET_QUESTIONARIO_SATISFACAO_VERIFICAR:
		"SET_QUESTIONARIO_SATISFACAO_VERIFICAR",
	SET_INFO_VERIFICACAO_QUESTIONARIO_SATISFACAO:
		"SET_INFO_VERIFICACAO_QUESTIONARIO_SATISFACAO",
	SALVAR_QUESTIONARIO_SATISFACAO: "SALVAR_QUESTIONARIO_SATISFACAO",
	SET_QUANTIDADE_EXECUCOES: "SET_QUANTIDADE_EXECUCOES",
	GET_QUANTIDADE_EXECUCOES: "GET_QUANTIDADE_EXECUCOES",
	NUMBER_LISTAGEM_PAGE: "NUMBER_LISTAGEM_PAGE",
	SET_SEARCH_PROTOCOL: "SET_SEARCH_PROTOCOL",
	SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
	SET_MODAL_SATISFACTION_UNIFIED_REPORT: 'SET_MODAL_SATISFACTION_UNIFIED_REPORT',
	SET_ID_RSPOSTA_HISTORY_REPORT_EVA: 'SET_ID_RSPOSTA_HISTORY_REPORT_EVA',
	SET_EVA_GOBACK: 'SET_EVA_GOBACK',
	PREENSAO_PALMAR_REQUEST: 'PREENSAO_PALMAR_REQUEST',
	PREENSAO_PALMAR_DATA: 'PREENSAO_PALMAR_DATA',
	AVALIACOES_DYNALABS_REQUEST: "AVALIACOES_REQUEST",
	AVALIACOES_DYNALABS_REQUEST_SUCCESS: "AVALIACOES_REQUEST_SUCCESS",
	AVALIACOES_DYNALABS_REQUEST_FAILURE: "AVALIACOES_REQUEST_FAILURE",

	ASSIMETRIAS_DYNALABS_REQUEST: "ASSIMETRIAS_REQUEST",
	ASSIMETRIAS_DYNALABS_REQUEST_SUCCESS: "ASSIMETRIAS_REQUEST_SUCCESS",
	ASSIMETRIAS_DYNALABS_REQUEST_FAILURE: "ASSIMETRIAS_REQUEST_FAILURE",

	CARGOS_REQUEST: "CARGOS_REQUEST",
	CARGOS_REQUEST_SUCCESS: "CARGOS_REQUEST_SUCCESS",
	CARGOS_REQUEST_FAILURE: "CARGOS_REQUEST_FAILURE",
	PORTA_ENTRADA_REQUEST: 'PORTA_ENTRADA_REQUEST',
	DATA_MANAGEMENT: 'DATA_MANAGEMENT',
	ENTRANCE_DOOR_DATA: 'ENTRANCE_DOOR_DATA',
	SET_CURRENT_COMPANY: 'SET_CURRENT_COMPANY',

	ANOTACOES_DYNALABS_REQUEST: "ANOTACOES_DYNALABS_REQUEST",
	ANOTACOES_DYNALABS_REQUEST_SUCCESS: "ANOTACOES_DYNALABS_REQUEST_SUCCESS",
	ANOTACOES_DYNALABS_REQUEST_FAILURE: "ANOTACOES_DYNALABS_REQUEST_FAILURE",

	ADICIONAR_ANOTACAO_DYNALABS_REQUEST: "ADICIONAR_ANOTACAO_DYNALABS_REQUEST",
	ADICIONAR_ANOTACAO_DYNALABS_REQUEST_SUCCESS: "ADICIONAR_ANOTACAO_DYNALABS_REQUEST_SUCCESS",
	ADICIONAR_ANOTACAO_DYNALABS_REQUEST_FAILURE: "ADICIONAR_ANOTACAO_DYNALABS_REQUEST_FAILURE",

	EDITAR_ANOTACAO_DYNALABS_REQUEST: "EDITAR_ANOTACAO_DYNALABS_REQUEST",
	EDITAR_ANOTACAO_DYNALABS_REQUEST_SUCCESS: "EDITAR_ANOTACAO_DYNALABS_REQUEST_SUCCESS",
	EDITAR_ANOTACAO_DYNALABS_REQUEST_FAILURE: "EDITAR_ANOTACAO_DYNALABS_REQUEST_FAILURE",

	EXCLUIR_ANOTACAO_DYNALABS_REQUEST: "EXCLUIR_ANOTACAO_DYNALABS_REQUEST",
	EXCLUIR_ANOTACAO_DYNALABS_REQUEST_SUCCESS: "EXCLUIR_ANOTACAO_DYNALABS_REQUEST_SUCCESS",
	EXCLUIR_ANOTACAO_DYNALABS_REQUEST_FAILURE: "EXCLUIR_ANOTACAO_DYNALABS_REQUEST_FAILURE",

	GERENCIAS_REQUEST: "GERENCIAS_REQUEST",
	GERENCIAS_REQUEST_SUCCESS: "GERENCIAS_REQUEST_SUCCESS",
	GERENCIAS_REQUEST_FAILURE: "GERENCIAS_REQUEST_FAILURE",
	REQUEST_NEW_PANEL_DASHBOARD_DYNALABS: 'REQUEST_NEW_PANEL_DASHBOARD_DYNALABS',
	FINISH_REQUEST_NEW_PANEL_DASHBOARD_DYNALABS: 'FINISH_REQUEST_NEW_PANEL_DASHBOARD_DYNALABS',
	SEARCH_SAVED_PANELS_REQUEST: 'SEARCH_SAVED_PANELS_REQUEST',
	SET_DATA_PANELS_SAVED: 'SET_DATA_PANELS_SAVED',
	REQUEST_EDIT_PANEL_CREATED_DASHBOARD_DYNALABS: 'REQUEST_EDIT_PANEL_CREATED_DASHBOARD_DYNALABS',
	REQUEST_DELETE_PANEL_CREATED_DASHBOARD_DYNALABS: 'REQUEST_DELETE_PANEL_CREATED_DASHBOARD_DYNALABS',
	FINISH_REQUEST_DELETE_PANEL_CREATED_DASHBOARD_DYNALABS: 'FINISH_REQUEST_DELETE_PANEL_CREATED_DASHBOARD_DYNALABS',
	SET_MODAL_DELETE_PANEL_CREATED:  'SET_MODAL_DELETE_PANEL_CREATED',
	SET_CREATING_NEW_DASHBOARD: 'SET_CREATING_NEW_DASHBOARD',
	SUCCESS_DELETED_PANEL: 'SUCCESS_DELETED_PANEL',
	PANEL_HAS_DELETED: 'PANEL_HAS_DELETED',
	SET_CURRENT_SELECTED_PANEL: 'SET_CURRENT_SELECTED_PANEL',
	REQUEST_VERIFY_ANSWER_NPS: 'REQUEST_VERIFY_ANSWER_NPS',
	REQUEST_SAVE_ANSWER_NPS: 'REQUEST_SAVE_ANSWER_NPS',
	SET_REQUEST_EXPORT_EXCEL_DASH: 'SET_REQUEST_EXPORT_EXCEL_DASH',
	SET_LAOD_REQUEST_EXPORT_EXCEL_DASH: 'SET_LAOD_REQUEST_EXPORT_EXCEL_DASH',
	REQUEST_RECOMENDACOES: 'REQUEST_RECOMENDACOES',
	SET_RECOMENDACAO_SUGESTAO_CONDUTA: 'SET_RECOMENDACAO_SUGESTAO_CONDUTA',
	SET_SUGESTAO_CONDUTA_RESULT: 'SET_SUGESTAO_CONDUTA_RESULT'
};

export const PACIENTES_PAGE_SIZE = 6;

function mergeUniquePacientes(existing: any, incoming: any) {
	const current = Array.isArray(existing) ? existing : [];
	const next = Array.isArray(incoming) ? incoming : [];
	const seen = new Set(current.map((paciente: any) => paciente?.ID_USUARIO));

	const appended = next.filter((paciente: any) => {
		const id = paciente?.ID_USUARIO;
		if (id == null || seen.has(id)) {
			return false;
		}
		seen.add(id);
		return true;
	});

	return [...current, ...appended];
}

function countUniquePacientes(existing: any, incoming: any) {
	return mergeUniquePacientes(existing, incoming).length -
		(Array.isArray(existing) ? existing.length : 0);
}

const INITIAL_STATE = {
	pacientes: null,
	number_pages_listagem: 1,
	pacientes_notification: [],
	total_pacientes: 0,
	pacientes_loading_more: false,
	pacientes_has_more: true,
	pacientes_next_offset: 0,
	total_avaliadores: null,
	filtros_pacintes_request: {
		inicio: 0,
		fim: PACIENTES_PAGE_SIZE,
		filtros: [
			{ tipo: "USUARIO_EXCLUIDO", valor: "N" },
			{ tipo: "USUARIO_NIVEL", valor: [3] },
		],
	},
	filtros_pacintes_notification_request: {
		inicio: 0,
		fim: 30,
		filtros: [
			{ tipo: "USUARIO_EXCLUIDO", valor: "N" },
			{ tipo: "USUARIO_NIVEL", valor: [3] },
		],
	},
	filtros_avaliadores_request: {
		inicio: 0,
		fim: 200,
		filtros: [
			{ tipo: "USUARIO_EXCLUIDO", valor: "N" },
			{ tipo: "USUARIO_NIVEL", valor: [1, 2] },
		],
	},
	avaliadores_request: false,
	execucoes: [],
	execucoes_excluidas: false,
	etiquetas: [],
	notificacoes: [],
	assimetria: [],
	desequilibrio: [],
	anamneses: [],
	anotacoes: [],
	dinamos: [],
	pacientes_loading: true,
	pacientes_notification_loading: true,
	avaliadores_loading: true,
	avaliadores: [],
	desativados: [],

	execucoes_loading: false,
	assimetria_loading: false,
	anamneses_loading: false,

	admin_master: null,
	pacientes_filtered: [],
	agrupamentos: [],
	search: "",
	search_protocol: [],
	dropdown: null,

	blog: false,
	set_blog: [],
	planos: [],

	select_info: "",
	button_search: false,
	current_page_patient: 1,
	current_page_evaluator: 1,
	pacientes_mais_visitados: [],
	pacientes_mais_visitados_request: false,
	categorias_protocolos: [],
	categorias_atribuidas: [],
	ids_storage_protocol: [],
	resposta_questionario_satisfacao: null,
	resposta_satisfacao_criado: null,
	data_salvar_questionario_satisfacao: {},
	set_quantidade_execucoes: null,
	current_page: "pacientes",
	modal_satisfaction_unified_report: false,
	id_resposta_hitory_report_eva: null,
	eva_goback: "",
	assimetrias_dynalabs: [],
	avaliacoes_dynalabs: [],
	cargos: [],
	management_data: [],
	entrance_door_data: [],
	current_company: '',
	anotacoes_dynalabs: [],
	gerencias: [],
	load_new_panel_dash_dynalabs: false,
	data_request_new_panel_dash_dynalabs:{},
	data_panels_saved:[],
	data_request_edit_panel_created_dash_dynalabs:{},
	data_delete_panel_created:{},
	load_delete_panel_dash_dynalabs: false,
	modal_delete_panel: false,
	creating_new_dash: false,
	panel_delete_success: false,
	panel_has_deleted: false,
	current_panel_selected: '',
	load_request_export_excel: false,
	data_recomendacao_conduta: undefined,
};

export default function dashboard(state = INITIAL_STATE, action: any) {
	switch (action.type) {
		case Types.PACIENTE_REQUEST: {
			const append = !!action.payload?.append;
			return {
				...state,
				pacientes_loading: append ? false : true,
				pacientes_loading_more: append,
				pacientes_has_more: append ? state.pacientes_has_more : true,
			};
		}
		case Types.PACIENTE_NOTIFICATION_REQUEST:
			return {
				...state,
				pacientes_notification_loading: true,
			};
		case Types.BLOG:
			return {
				...state,
				blog: true,
			};
		case Types.SET_BLOG:
			return {
				...state,
				set_blog: action.payload,
			};
		case Types.PACIENTE_REQUEST_SUCCESS: {
			const incoming = Array.isArray(action.payload) ? action.payload : [];
			const append = !!action.append;
			const uniqueItemsAdded = append
				? countUniquePacientes(state.pacientes, incoming)
				: incoming.length;
			const pageSize = append
				? PACIENTES_PAGE_SIZE
				: Math.max(
						(state.filtros_pacintes_request?.fim ?? PACIENTES_PAGE_SIZE) -
							(state.filtros_pacintes_request?.inicio ?? 0),
						1
				  );

			const requestStart =
				action.pagination?.inicio ??
				(append
					? state.pacientes_next_offset
					: state.filtros_pacintes_request?.inicio ?? 0);
			const nextOffset = requestStart + incoming.length;
			const total = action.pagination?.total;
			const hasMoreByTotal =
				total == null || Number(total) <= 0 || nextOffset < Number(total);

			return {
				...state,
				pacientes: append
					? mergeUniquePacientes(state.pacientes, incoming)
					: incoming,
				pacientes_loading: false,
				pacientes_loading_more: false,
				pacientes_has_more:
					uniqueItemsAdded > 0 && incoming.length >= pageSize && hasMoreByTotal,
				pacientes_next_offset: nextOffset,
			};
		}
		case Types.PACIENTE_NOTIFICATION_REQUEST_SUCCESS:
			return {
				...state,
				pacientes_notification: action.payload,
				pacientes_notification_loading: false,
			};
		case Types.PACIENTE_STOP_REQUEST:
			return {
				...state,
				pacientes_loading: false,
				pacientes_loading_more: false,
				pacientes_has_more: false,
			};

		case Types.SER_AVALIADORES:
			return {
				...state,
				avaliadores: action.payload,
				avaliadores_loading: false,
			};
		case Types.SET_USER_MASTER:
			return {
				...state,
				admin_master: action.payload,
			};
		case Types.PACIENTE_FILTERED:
			return {
				...state,
				pacientes_filtered: action.payload,
			};
		case Types.SET_DESATIVADOS:
			return {
				...state,
				desativados: action.payload,
			};
		case Types.SET_AGRUPAMENTOS:
			return {
				...state,
				agrupamentos: action.payload,
			};
		case Types.SET_SEARCH:
			return {
				...state,
				search: action.payload,
			};
		case Types.SET_DROP_DOWN:
			return {
				...state,
				dropdown: action.payload,
			};
		case Types.EXECUCOES_REQUEST_SUCCESS:
			return {
				...state,
				execucoes: action.payload,
			};
		case Types.EXECUCOES_REQUEST:
			return {
				...state,
				execucoes_excluidas: action.payload,
			};
		case Types.EXECUCOES_REQUEST_LOADING:
			return {
				...state,
				execucoes_loading: action.payload,
			};
		case Types.ASSIMETRIA_REQUEST_SUCCESS:
			return {
				...state,
				assimetria: action.payload,
			};
		case Types.DESEQUILIBRIO_REQUEST_SUCCESS:
			return {
				...state,
				desequilibrio: action.payload,
			};
		case Types.ASSIMETRIA_REQUEST_LOADING:
			return {
				...state,
				assimetria_loading: action.payload,
			};
		case Types.ANAMNESES_REQUEST_SUCCESS:
			return {
				...state,
				anamneses: action.payload,
			};
		case Types.ANAMNESES_REQUEST_LOADING:
			return {
				...state,
				anamneses_loading: action.payload,
			};
		case Types.ANOTACOES_REUQUEST_SUCCESS:
			return {
				...state,
				anotacoes: action.payload,
			};
		case Types.ETIQUETAS_REQUEST_SUCCESS:
			return {
				...state,
				etiquetas: action.payload,
			};
		case Types.NOTIFICACOES_REQUEST_SUCCESS:
			return {
				...state,
				notificacoes: action.payload,
			};
		case Types.DINAMOS_REQUEST_SUCCESS:
			return {
				...state,
				dinamos: action.payload,
			};
		case Types.LOADING:
			return {
				...state,
				pacientes_loading: action.payload,
			};
		case Types.PLANOS_REQUEST_SUCCESS:
			return {
				...state,
				planos: action.payload,
			};
		case Types.SELECT_INFO:
			return {
				...state,
				select_info: action.payload,
			};
		case Types.TOTAL_PACIENTES:
			return {
				...state,
				total_pacientes: action.payload,
			};
		case Types.PACIENTE_REQUEST_FILTROS:
			return {
				...state,
				filtros_pacintes_request: action.payload,
			};
		case Types.PACIENTE_NOTIFICATION_REQUEST_FILTROS:
			return {
				...state,
				filtros_pacintes_notification_request: action.payload,
			};
		case Types.AVALIADOR_REQUEST_FILTROS:
			return {
				...state,
				filtros_avaliadores_request: action.payload,
			};
		case Types.SET_BUTTON_SEARCH:
			return {
				...state,
				button_search: action.payload,
			};
		case Types.AVALIADORES_REQUEST:
			return {
				...state,
				avaliadores_request: action.payload,
				avaliadores_loading: true,
			};
		case Types.SET_CURRENT_PAGE_PATIENT:
			return {
				...state,
				current_page_patient: action.payload,
			};
		case Types.SET_PACIENTES_MAIS_VISITADOS:
			return {
				...state,
				pacientes_mais_visitados: action.payload,
			};
		case Types.PACIENTES_MAIS_VISITADOS_REQUEST:
			return {
				...state,
				pacientes_mais_visitados_request: action.payload,
			};
		case Types.TOTAL_AVALIADORES:
			return {
				...state,
				total_avaliadores: action.payload,
			};
		case Types.SET_CATEGORIAS_PROTOCOLOS:
			return {
				...state,
				categorias_protocolos: action.payload,
			};
		case Types.GET_CATEGORIAS_ATRIBUIDAS:
			return {
				...state,
				categorias_atribuidas: action.payload,
			};
		case Types.SEARCH_PROTOCOL_IN_STORAGE:
			return {
				...state,
				ids_storage_protocol: action.payload,
			};
		case Types.SET_INFO_VERIFICACAO_QUESTIONARIO_SATISFACAO:
			return {
				...state,
				resposta_questionario_satisfacao: action.payload.respondido,
				resposta_satisfacao_criado: action.payload.resposta,
			};
		case Types.NUMBER_LISTAGEM_PAGE:
			return {
				...state,
				number_pages_listagem: action.payload,
			};
		case Types.SALVAR_QUESTIONARIO_SATISFACAO:
			return {
				...state,
				data_salvar_questionario_satisfacao: {
					txDataHora: action.payload.txDataHora,
					txTipo: action.payload.txTipo,
					RESPOSTA_ID_TIPO: action.payload.RESPOSTA_ID_TIPO,
					RESPOSTA_VALOR: action.payload.RESPOSTA_VALOR,
					RESPOSTA_COMPLEMENTO: action.payload.RESPOSTA_COMPLEMENTO,
					txCategorias: action.payload.txCategorias,
				},
			};
		case Types.SET_QUANTIDADE_EXECUCOES:
			return {
				...state,
				set_quantidade_execucoes: action.payload,
			};
		case Types.SET_CURRENT_PAGE_EVALUATOR:
			return {
				...state,
				current_page_evaluator: action.payload,
			};
		case Types.SET_SEARCH_PROTOCOL:
			return {
				...state,
				search_protocol: action.payload,
			};
		case Types.SET_CURRENT_PAGE:
			return {
				...state,
				current_page: action.payload,
			};
		case Types.SET_MODAL_SATISFACTION_UNIFIED_REPORT:
			return {
				...state,
				modal_satisfaction_unified_report: action.payload,
			};
		case Types.SET_ID_RSPOSTA_HISTORY_REPORT_EVA:
			return {
				...state,
				id_resposta_hitory_report_eva: action.payload,
			};
		case Types.SET_EVA_GOBACK:
			return {
				...state,
				eva_goback: action.payload,
			}
		case Types.PREENSAO_PALMAR_DATA:
			return {
				...state,
				palmar_gripe_data: action.payload,
			};
		case Types.ASSIMETRIAS_DYNALABS_REQUEST_SUCCESS:
			return {
				...state,
				assimetrias_dynalabs: action.payload,
			};
		case Types.ASSIMETRIAS_DYNALABS_REQUEST_FAILURE:
			return {
				...state,
				assimetrias_dynalabs: [],
			};
		case Types.AVALIACOES_DYNALABS_REQUEST_SUCCESS:
			return {
				...state,
				avaliacoes_dynalabs: action.payload,
			};
		case Types.AVALIACOES_DYNALABS_REQUEST_FAILURE:
			return {
				...state,
				avaliacoes_dynalabs: [],
			};

		case Types.CARGOS_REQUEST_SUCCESS:
			return {
				...state,
				cargos: action.payload,
			};
		case Types.CARGOS_REQUEST_FAILURE:
			return {
				...state,
				cargos: [],
			};
		case Types.DATA_MANAGEMENT:
			return {
				...state,
				management_data: action.payload,
			};
		case Types.ENTRANCE_DOOR_DATA:
			return {
				...state,
				entrance_door_data: action.payload,
			};
		case Types.SET_CURRENT_COMPANY:
			return {
				...state,
				current_company: action.payload,
			}
		case Types.ANOTACOES_DYNALABS_REQUEST_SUCCESS:
			return {
				...state,
				anotacoes_dynalabs: action.payload,
			};
		case Types.ANOTACOES_DYNALABS_REQUEST_FAILURE:
			return {
				...state,
				anotacoes_dynalabs: [],
			};

		case Types.ADICIONAR_ANOTACAO_DYNALABS_REQUEST_SUCCESS:
			return {
				...state,
				anotacoes_dynalabs: action.payload,
			};
		case Types.ADICIONAR_ANOTACAO_DYNALABS_REQUEST_FAILURE:
			return {
				...state,
				anotacoes_dynalabs: [],
			};

		case Types.EDITAR_ANOTACAO_DYNALABS_REQUEST_SUCCESS:
			return {
				...state,
				anotacoes_dynalabs: action.payload,
			};
		case Types.EDITAR_ANOTACAO_DYNALABS_REQUEST_FAILURE:
			return {
				...state,
				anotacoes_dynalabs: [],
			};

		case Types.EXCLUIR_ANOTACAO_DYNALABS_REQUEST_SUCCESS:
			return {
				...state,
				anotacoes_dynalabs: action.payload,
			};
		case Types.EXCLUIR_ANOTACAO_DYNALABS_REQUEST_FAILURE:
			return {
				...state,
				anotacoes_dynalabs: [],
			};

		case Types.GERENCIAS_REQUEST_SUCCESS:
			return {
				...state,
				gerencias: action.payload,
			};
		case Types.GERENCIAS_REQUEST_FAILURE:
			return {
				...state,
				gerencias: [],
			};
		case Types.REQUEST_NEW_PANEL_DASHBOARD_DYNALABS:
			return {
				...state,
				load_new_panel_dash_dynalabs: true,
				data_request_new_panel_dash_dynalabs: action.payload
			};
		case Types.FINISH_REQUEST_NEW_PANEL_DASHBOARD_DYNALABS:
			return {
				...state,
				load_new_panel_dash_dynalabs: false,
				
			};
		case Types.SET_DATA_PANELS_SAVED:
			return {
				...state,
				data_panels_saved: action.payload,
			};
		case Types.REQUEST_EDIT_PANEL_CREATED_DASHBOARD_DYNALABS:
			return {
				...state,
				load_new_panel_dash_dynalabs: true,
				data_request_new_panel_dash_dynalabs: action.payload,
			};
		case Types.REQUEST_DELETE_PANEL_CREATED_DASHBOARD_DYNALABS:
			return {
				...state,
				load_delete_panel_dash_dynalabs: true,
				data_delete_panel_created: action.payload,
			};
		case Types.FINISH_REQUEST_DELETE_PANEL_CREATED_DASHBOARD_DYNALABS:
			return {
				...state,
				load_delete_panel_dash_dynalabs: false,
			};
		case Types.SET_MODAL_DELETE_PANEL_CREATED:
			return {
				...state,
				modal_delete_panel: action.payload,
			};
		case Types.SET_CREATING_NEW_DASHBOARD:
			return {
				...state,
				creating_new_dash: action.payload,
			};
		case Types.SUCCESS_DELETED_PANEL:
			return {
				...state,
				panel_delete_success: action.payload,
			};
		case Types.PANEL_HAS_DELETED:
			return {
				...state,
				panel_has_deleted: action.payload,
			};
		case Types.SET_CURRENT_SELECTED_PANEL:
			return {
				...state,
				current_panel_selected: action.payload,
			};
		case Types.SET_LAOD_REQUEST_EXPORT_EXCEL_DASH:
			return {
				...state,
				load_request_export_excel: action.payload,
			};
		case Types.SET_RECOMENDACAO_SUGESTAO_CONDUTA:
			return {
				...state,
				data_recomendacao_conduta: action.payload,
			};

		default:
			return state;
	}
}

export const DashBoardActions = {
	paciente_request: (payload?: {
		append?: boolean;
		inicio?: number;
		fim?: number;
	}) => ({
		type: Types.PACIENTE_REQUEST,
		payload,
	}),
	paciente_notification_request: () => ({
		type: Types.PACIENTE_NOTIFICATION_REQUEST,
	}),
	paciente_success: (
		pacientes: any,
		append = false,
		pagination?: { inicio?: number; total?: number }
	) => ({
		type: Types.PACIENTE_REQUEST_SUCCESS,
		payload: pacientes,
		append,
		pagination,
	}),
	set_number_page: (number_page: number) => ({
		type: Types.NUMBER_LISTAGEM_PAGE,
		payload: number_page,
	}),
	paciente_notification_success: (pacientes: any) => ({
		type: Types.PACIENTE_NOTIFICATION_REQUEST_SUCCESS,
		payload: pacientes,
	}),
	total_pacientes: (total_pacientes: any) => ({
		type: Types.TOTAL_PACIENTES,
		payload: total_pacientes,
	}),
	total_avaliadores: (total_avaliadores: any) => ({
		type: Types.TOTAL_AVALIADORES,
		payload: total_avaliadores,
	}),
	set_filtros_pacintes_request: (filtros_pacintes_request: any) => ({
		type: Types.PACIENTE_REQUEST_FILTROS,
		payload: filtros_pacintes_request,
	}),
	set_filtros_pacintes_notification_request: (
		filtros_pacintes_request: any
	) => ({
		type: Types.PACIENTE_NOTIFICATION_REQUEST_FILTROS,
		payload: filtros_pacintes_request,
	}),
	set_filtros_avaliadores_request: (filtros_avaliadores_request: any) => ({
		type: Types.AVALIADOR_REQUEST_FILTROS,
		payload: filtros_avaliadores_request,
	}),
	set_blog: (set_blog: any) => ({
		type: Types.SET_BLOG,
		payload: set_blog,
	}),
	blog_request: () => ({
		type: Types.BLOG,
	}),
	paciente_stop_request: () => ({
		type: Types.PACIENTE_STOP_REQUEST,
	}),
	set_avaliadores: (avaliadores: any) => ({
		type: Types.SER_AVALIADORES,
		payload: avaliadores,
	}),
	set_admin_master: (user_mas: any) => ({
		type: Types.SET_USER_MASTER,
		payload: user_mas,
	}),
	set_paciente_filtered: (pacientes: any) => ({
		type: Types.PACIENTE_FILTERED,
		payload: pacientes,
	}),
	set_desativados: (paciente: any) => ({
		type: Types.SET_DESATIVADOS,
		payload: paciente,
	}),
	protocolos_request: () => ({
		type: Types.PROTOCOLOS_REQUEST,
	}),
	set_agrupamentos: (agrupamentos: any) => ({
		type: Types.SET_AGRUPAMENTOS,
		payload: agrupamentos,
	}),
	exercices_request: () => ({
		type: Types.EXERCICES_REQUEST,
	}),
	set_search: (texto: any) => ({
		type: Types.SET_SEARCH,
		payload: texto,
	}),
	set_search_protocol: (texto: any) => ({
		type: Types.SET_SEARCH_PROTOCOL,
		payload: texto,
	}),
	execucoes_request: (execucoes_excluidas: boolean) => ({
		type: Types.EXECUCOES_REQUEST,
		payload: execucoes_excluidas,
	}),
	execucoes_request_sucess: (execucoes: any) => ({
		type: Types.EXECUCOES_REQUEST_SUCCESS,
		payload: execucoes,
	}),
	execucoes_request_loading: (loading: any) => ({
		type: Types.EXECUCOES_REQUEST_LOADING,
		payload: loading,
	}),
	set_dropdown: (texto: any) => ({
		type: Types.SET_DROP_DOWN,
		payload: texto,
	}),
	etiquetas_request: () => ({
		type: Types.ETIQUETAS_REQUEST,
	}),
	etiquetas_request_success: (etiquetas: any) => ({
		type: Types.ETIQUETAS_REQUEST_SUCCESS,
		payload: etiquetas,
	}),
	notificacoes_request: () => ({
		type: Types.NOTIFICACOES_REQUEST,
	}),
	notificacoes_request_success: (notificacoes: any) => ({
		type: Types.NOTIFICACOES_REQUEST_SUCCESS,
		payload: notificacoes,
	}),
	assimetria_request: () => ({
		type: Types.ASSIMETRIA_REQUEST,
	}),
	assimetria_request_success: (assimetrias: any) => ({
		type: Types.ASSIMETRIA_REQUEST_SUCCESS,
		payload: assimetrias,
	}),
	desequilibrios_request_success: (desequilibrios: any) => ({
		type: Types.DESEQUILIBRIO_REQUEST_SUCCESS,
		payload: desequilibrios,
	}),
	assimetria_request_loading: (loading: any) => ({
		type: Types.ASSIMETRIA_REQUEST_LOADING,
		payload: loading,
	}),
	anamneses_request: () => ({
		type: Types.ANAMNESES_REQUEST,
	}),
	anamneses_request_success: (anamneses: any) => ({
		type: Types.ANAMNESES_REQUEST_SUCCESS,
		payload: anamneses,
	}),
	anamneses_request_loading: (loading: any) => ({
		type: Types.ANAMNESES_REQUEST_LOADING,
		payload: loading,
	}),
	anotacoes_request: () => ({
		type: Types.ANOTACOES_REQUEST,
	}),
	exercicios_avaliados_request: () => ({
		type: Types.EXERCICIOS_AVALIADOS_REQUEST,
	}),
	anotacoes_request_success: (anotacoes: any) => ({
		type: Types.ANOTACOES_REUQUEST_SUCCESS,
		payload: anotacoes,
	}),
	dinamos_request: () => ({
		type: Types.DINAMOS_REQUEST,
	}),
	dinamos_request_success: (dinos: any) => ({
		type: Types.DINAMOS_REQUEST_SUCCESS,
		payload: dinos,
	}),
	set_loading: (dinos: any) => ({
		type: Types.LOADING,
		payload: dinos,
	}),
	planos_request: () => ({
		type: Types.PLANOS_REQUEST_SUCCESS,
	}),
	planos_request_success: (anotacoes: any) => ({
		type: Types.ANOTACOES_REUQUEST_SUCCESS,
		payload: anotacoes,
	}),
	set_select_info: (info: any) => ({
		type: Types.SELECT_INFO,
		payload: info,
	}),
	set_button_search: (payload: any) => ({
		type: Types.SET_BUTTON_SEARCH,
		payload: payload,
	}),
	avaliadores_request: () => ({
		type: Types.AVALIADORES_REQUEST,
	}),
	set_current_page_patient: (payload: any) => ({
		type: Types.SET_CURRENT_PAGE_PATIENT,
		payload: payload,
	}),
	set_current_page_evaluator: (payload: any) => ({
		type: Types.SET_CURRENT_PAGE_EVALUATOR,
		payload: payload,
	}),
	set_pacientes_mais_visitados: (payload: any) => ({
		type: Types.SET_PACIENTES_MAIS_VISITADOS,
		payload: payload,
	}),
	mais_visitados_request: () => ({
		type: Types.PACIENTES_MAIS_VISITADOS_REQUEST,
	}),
	call_categorias_protocolos: () => ({
		type: Types.CATEGORIAS_PROTOCOLOS,
	}),
	set_categorias_protocolos_in_modal_filter_protocol: (categorias: any) => ({
		type: Types.SET_CATEGORIAS_PROTOCOLOS,
		payload: categorias,
	}),
	set_atribuir_categorias_protocolos: (
		txDataHora: string,
		id_usuario: number,
		id_categorias: number[]
	) => ({
		type: Types.ATRIBUIR_CATEGORIA_PROTOCOLOS,
		payload: { txDataHora, id_usuario, id_categorias },
	}),
	search_categorias_atribuidas: (id_usuario: number) => ({
		type: Types.SEARCH_CATEGORIAS_ATRIBUIDAS,
		payload: id_usuario,
	}),
	get_categorias_atribuidas: (categorias_atribuidas: any) => ({
		type: Types.GET_CATEGORIAS_ATRIBUIDAS,
		payload: categorias_atribuidas,
	}),
	search_protocol_in_storage: (ids: number[]) => ({
		type: Types.SEARCH_PROTOCOL_IN_STORAGE,
		payload: ids,
	}),
	set_questionario_satisfacao_verificar: (
		resposta_id_tipo: any,
		txTipo: string
	) => ({
		type: Types.SET_QUESTIONARIO_SATISFACAO_VERIFICAR,
		payload: { resposta_id_tipo, txTipo },
	}),
	set_questionario_satisfacao_verificar_tipos_modal_satisfacao_exame: (
		txTipos: string[]
	) => ({
		type: Types.SET_QUESTIONARIO_SATISFACAO_VERIFICAR,
		payload: { txTipos },
	}),
	set_info_questionario_satisfacao: (respondido: any, resposta: any) => ({
		type: Types.SET_INFO_VERIFICACAO_QUESTIONARIO_SATISFACAO,
		payload: { respondido, resposta },
	}),
	set_salvar_questionario_satisfacao: (
		txDataHora: string,
		txTipo: string,
		RESPOSTA_VALOR?: string[] | number[],
		RESPOSTA_COMPLEMENTO?: string[],
		RESPOSTA_ID_TIPO?: number | string,
		txCategorias?: string[]
	) => ({
		type: Types.SALVAR_QUESTIONARIO_SATISFACAO,
		payload: {
			txDataHora,
			txTipo,
			RESPOSTA_ID_TIPO,
			RESPOSTA_VALOR,
			RESPOSTA_COMPLEMENTO,
			txCategorias,
		},
	}),
	set_amount_executions: (amount: number | null) => ({
		type: Types.SET_QUANTIDADE_EXECUCOES,
		payload: amount,
	}),
	set_get_amount_executions: () => ({
		type: Types.GET_QUANTIDADE_EXECUCOES,
	}),
	set_current_page: (payload: any) => ({
		type: Types.SET_CURRENT_PAGE,
		payload: payload,
	}),
	set_modal_satisfaction_unified_report: (respondido: boolean) => ({
		type: Types.SET_MODAL_SATISFACTION_UNIFIED_REPORT,
		payload: respondido,
	}),
	set_id_resposta_history_report_eva: (id: number) => ({
		type: Types.SET_ID_RSPOSTA_HISTORY_REPORT_EVA,
		payload: id,
	}),
	set_eva_goBack: (goback: string) => ({
		type: Types.SET_EVA_GOBACK,
		payload: goback,
	}),
	preensao_palmar_request: (userId:number)=> ({
		type: Types.PREENSAO_PALMAR_REQUEST,
		payload: userId
	}),
	set_data_palmar_gripe_report: (data:any)=> ({
		type: Types.PREENSAO_PALMAR_DATA,
		payload: data
	}),
	avaliacoes_request: () => ({
		type: Types.AVALIACOES_DYNALABS_REQUEST,
	}),
	avaliacoes_request_success: (avaliacoes: any) => ({
		type: Types.AVALIACOES_DYNALABS_REQUEST_SUCCESS,
		payload: avaliacoes,
	}),
	avaliacoes_request_failure: (error: any) => ({
		type: Types.AVALIACOES_DYNALABS_REQUEST_FAILURE,
		payload: error,
	}),
	assimetrias_dynalabs_request: () => ({
		type: Types.ASSIMETRIAS_DYNALABS_REQUEST,
	}),
	assimetrias_dynalabs_request_success: (assimetrias: any) => ({
		type: Types.ASSIMETRIAS_DYNALABS_REQUEST_SUCCESS,
		payload: assimetrias,
	}),
	assimetrias_dynalabs_request_failure: (error: any) => ({
		type: Types.ASSIMETRIAS_DYNALABS_REQUEST_FAILURE,
		payload: error,
	}),
	cargos_request: () => ({
		type: Types.CARGOS_REQUEST,
	}),
	cargos_request_success: (cargos: any) => ({
		type: Types.CARGOS_REQUEST_SUCCESS,
		payload: cargos,
	}),
	cargos_request_failure: (error: any) => ({
		type: Types.CARGOS_REQUEST_FAILURE,
		payload: error,
	}),
	sync_gerencias_request: ()=> ({
		type: Types.GERENCIAS_REQUEST,
	}),
	sync_porta_entrada_request: ()=> ({
		type: Types.PORTA_ENTRADA_REQUEST,
	}),
	set_management_data: (data:Array<
		{
			ID_GERENCIA:number;
			GERENCIA_TITULO: string;
			GERENCIA_EXCLUIDO: string;
			GERENCIA_ATUALIZADO: string;
			GERENCIA_CRIADO: string;
		}
	>)=> ({
		type: Types.DATA_MANAGEMENT,
		payload: data
	}),
	set_entrance_door_data: (data:Array<
		{
			ID_PORTA_ENTRADA:number;
			PORTA_ENTRADA_TITULO: string;
			PORTA_ENTRADA_EXCLUIDO: string;
			PORTA_ENTRADA_ATUALIZADO: string;
			PORTA_ENTRADA_CRIADO: string;
		}
	>)=> ({
		type: Types.ENTRANCE_DOOR_DATA,
		payload: data
	}),
	set_current_company: (company: string)=> ({
		type: Types.SET_CURRENT_COMPANY,
		payload: company
	}),
	anotacoes_dynalabs_request: () => ({
		type: Types.ANOTACOES_DYNALABS_REQUEST,
	}),
	anotacoes_dynalabs_request_success: (anotacoes: any) => ({
		type: Types.ANOTACOES_DYNALABS_REQUEST_SUCCESS,
		payload: anotacoes,
	}),
	anotacoes_dynalabs_request_failure: (error: any) => ({
		type: Types.ANOTACOES_DYNALABS_REQUEST_FAILURE,
		payload: error,
	}),
	adicionar_anotacao_dynalabs_request: (anotacao: any) => ({
		type: Types.ADICIONAR_ANOTACAO_DYNALABS_REQUEST,
		payload: anotacao,
	}),
	adicionar_anotacao_dynalabs_request_success: (response: any) => ({
		type: Types.ADICIONAR_ANOTACAO_DYNALABS_REQUEST_SUCCESS,
		payload: response,
	}),
	adicionar_anotacao_dynalabs_request_failure: (error: any) => ({
		type: Types.ADICIONAR_ANOTACAO_DYNALABS_REQUEST_FAILURE,
		payload: error,
	}),
	editar_anotacao_dynalabs_request: (anotacao: any) => ({
		type: Types.EDITAR_ANOTACAO_DYNALABS_REQUEST,
		payload: anotacao,
	}),
	editar_anotacao_dynalabs_request_success: (response: any) => ({
		type: Types.EDITAR_ANOTACAO_DYNALABS_REQUEST_SUCCESS,
		payload: response,
	}),
	editar_anotacao_dynalabs_request_failure: (error: any) => ({
		type: Types.EDITAR_ANOTACAO_DYNALABS_REQUEST_FAILURE,
		payload: error,
	}),
	excluir_anotacao_dynalabs_request: (idAnotacao: number) => ({
		type: Types.EXCLUIR_ANOTACAO_DYNALABS_REQUEST,
		payload: idAnotacao,
	}),
	excluir_anotacao_dynalabs_request_success: (response: any) => ({
		type: Types.EXCLUIR_ANOTACAO_DYNALABS_REQUEST_SUCCESS,
		payload: response,
	}),
	excluir_anotacao_dynalabs_request_failure: (error: any) => ({
		type: Types.EXCLUIR_ANOTACAO_DYNALABS_REQUEST_FAILURE,
		payload: error,
	}),
	gerencias_request: () => ({
		type: Types.GERENCIAS_REQUEST,
	}),
	gerencias_request_success: (gerencias: any) => ({
		type: Types.GERENCIAS_REQUEST_SUCCESS,
		payload: gerencias,
	}),
	gerencias_request_failure: (error: any) => ({
		type: Types.GERENCIAS_REQUEST_FAILURE,
		payload: error,
	}),
	set_request_new_panel_dashboard_dynalabs: (data: panelCreatedProps) => ({
		type: Types.REQUEST_NEW_PANEL_DASHBOARD_DYNALABS,
		payload: data,
	}),
	set_request_edit_panel_created_dashboard_dynalabs: (data: panelCreatedProps) => ({
		type: Types.REQUEST_EDIT_PANEL_CREATED_DASHBOARD_DYNALABS,
		payload: data,
	}),
	set_finish_request_new_panel_dashboard_dynalabs: () => ({
		type: Types.FINISH_REQUEST_NEW_PANEL_DASHBOARD_DYNALABS,
	}),
	search_saved_panels_request: () => ({
		type: Types.SEARCH_SAVED_PANELS_REQUEST,
	}),
	set_data_panels_saved: (data:any[]) => ({
		type: Types.SET_DATA_PANELS_SAVED,
		payload: data
	}),
	set_request_delete_panel_created_dashboard_dynalabs: (data: {txDataHora: string, ID_FILTRO: number }) => ({
		type: Types.REQUEST_DELETE_PANEL_CREATED_DASHBOARD_DYNALABS,
		payload: data,
	}),
	finish_request_delete_panel_created_dashboard_dynalabs: () => ({
		type: Types.FINISH_REQUEST_DELETE_PANEL_CREATED_DASHBOARD_DYNALABS,
	}),
	set_modal_delete_panel_created: (status: boolean) => ({
		type: Types.SET_MODAL_DELETE_PANEL_CREATED,
		payload: status
	}),
	set_creating_new_dashboard: (status: boolean) => ({
		type: Types.SET_CREATING_NEW_DASHBOARD,
		payload: status
	}),
	success_deleted_panel: (status: boolean) => ({
		type: Types.SUCCESS_DELETED_PANEL,
		payload: status
	}),
	panel_has_deleted: (status: boolean) => ({
		type: Types.PANEL_HAS_DELETED,
		payload: status
	}),
	set_current_selected_panel: (panel: string) => ({
		type: Types.SET_CURRENT_SELECTED_PANEL,
		payload: panel
	}),
	set_request_verify_answer_nps: (txTrimestre: string) => ({
		type: Types.REQUEST_VERIFY_ANSWER_NPS,
		payload:txTrimestre ,
	}),
	set_request_save_answer_nps: (
		txTrimestre: string,
		firstAnswer: string ,
		secondAnswer = ''
	) => ({
		type: Types.REQUEST_SAVE_ANSWER_NPS,
		payload:{txTrimestre, firstAnswer, secondAnswer} ,
	}),
	set_request_export_excel_dash: (dataRequest: {
		txDash: string,
		txPeriodo: string,
		ID_FILTRO: number
	}) => ({
		type: Types.SET_REQUEST_EXPORT_EXCEL_DASH,
		payload: dataRequest
	}),
	set_load_request_export_excel_dash: (status: boolean) => ({
		type: Types.SET_LAOD_REQUEST_EXPORT_EXCEL_DASH,
		payload: status
	}),
	set_request_recomendacoes: (id_user:number)=> ({
		type: Types.REQUEST_RECOMENDACOES,
		payload: id_user
	}),
	set_recomendacao_sugestao_conduta: (data: dataHistoryRecomendationProps)=> ({
		type: Types.SET_RECOMENDACAO_SUGESTAO_CONDUTA,
		payload: data
	}),
	set_sugestao_conduta_result: (data: string)=> ({
		type: Types.SET_SUGESTAO_CONDUTA_RESULT,
		payload: data
	}),
};
